import { DynamicFormControlModel } from '@ng-dynamic-forms/core';
import { COMPONENT_MODE } from './shared/workflow-components/workflow-components.models';
import * as moment from 'moment';
import { FormGroup } from '@angular/forms';
import { Model_FileExcelStructureProperties } from './pages/views/administration/reporting/file-excel-builder/file-excel-builder.model';
import { Model_FileTextStructure } from './pages/views/administration/reporting/file-text-builder/file-text-builder.model';
import { string } from 'mathjs';

// #region Core
export class Model_SystemeInformation {
    ID: string;
    CODE_SYSTEME_INFORMATION: string;
    LIBELLE: string;
    VERSIONS: string[];
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
}

export class Model_User {
    ID: string;
    USERNAME: string;
    EMAIL: string;
    PASSWORD: string;
    PASSWORD_HASH: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    ROLE_ID: ROLE_USER;
}

export class Model_Agent {
    ID: string;
    NOM: string;
    PRENOM: string;
    USERNAME: string;
    EMAIL: string;
    PASSWORD: string;
    PASSWORD_HASH: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    CODE_SOCIETE: string;
    SOCIETE_ID: string;
    SOMMEIL: boolean;
    ROLE_ID: ROLE_USER;
    HAS_DEFAULT_PASSWORD: boolean;
    PASSWORD_CHANGED_AT: string;
}

export class AgentSaveRequestDTO {
    ID: string;
    USERNAME: string;
    EMAIL: string;
    PASSWORD: string;
    PASSWORD_HASH: string;
    SOCIETE_ID: string;
}

export class Model_TeamAssignationAgent {
    TEAM_ID: string;
    USER_ID: string;
    ASSIGNED: boolean;
    SUPERVISEUR: boolean;
    DATE_DEBUT_ASSIGNATION: Date;
    DATE_FIN_ASSIGNATION: Date;
    AGENT: Model_Agent;
}

export class Model_Societe {
    ID: string;
    CODE_SOCIETE: string;
    NOM_SOCIETE: string;
    NOM_BASE: string;
    DOMAINE: string;
    CONNECTION_STRING: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    CODE_SYSTEME_INFORMATION: string;
    VERSION_SYSTEME_INFORMATION: string;

    STATUS_WORKSPACE?: INSTALLATION_STATUS_SOCIETE;
}

export enum CODES_SYSTEMES_INFORMATIONS {
    SAGE = 'SAGE'
}

export class Model_Team {
    ID: string;
    CODE_SOCIETE: string;
    NOM: string;
    SOMMEIL: boolean;
    SOCIETE_ID: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    AGENTS: Model_Agent[];
    SUPERVISEURS: Model_Agent[];
    WORKFLOWS: Model_Workflow[];
    AGENTS_GRID: AbsPaginatedGrid<Model_Agent>;
    WORKFLOWS_GRID: AbsPaginatedGrid<Model_Workflow>;
}

export class Model_Peripherique {
    ID: string;
    LABEL: string;
    ANDROID_ID: string;
    MAC_ADDRESS: string;
    IP_ADDRESS: string;
    SUBNET_MASK: string;
    DATE_CREATION: Date;
    DATE_MODIFICATION: Date;
    DATE_SUPPRESSION: Date;
    DATE_ACTIVATION: Date;
    SOMMEIL: boolean;
    IS_ENABLED: boolean;
    SOCKET_CONNECTION_ID: string;
    APP_VERSION_CODE: string;
    APP_VERSION_DISPLAY: string;
    DATE_LAST_MAJ: Date;
    MARQUE: string;
    MODELE: string;
}

export class Model_PeripheriqueAssignationAgent {
    PERIPHERIQUE_ID: string;
    UTILISATEUR_ID: string;
    SOCIETE_ID: string;
    CODE_SOCIETE: string;
    DATE_DEBUT_ASSIGNATION?: Date;
    DATE_FIN_ASSIGNATION?: Date;
    AGENT_USERNAME: string;
    AGENT: Model_Agent;
    SOCIETE: Model_Societe;
}

export class PeripheriqueAssignationAgentSaveRequestDTO {
    PERIPHERIQUE_ID: string;
    UTILISATEUR_ID: string;
    SOCIETE_ID: string;
}

export class PeripheriqueSaveRequestDTO {
    ID: string;
    LABEL: string;
    MAC_ADDRESS: string;
    IP_ADDRESS: string;
    SUBNET_MASK: string;
    MARQUE: string;
    MODELE: string;
}

export class TeamSaveRequestDTO {
    ID: string;
    NOM: string;
    SOCIETE_ID: string;
}

export class TeamAssignationAgentSaveRequestDTO {
    SOCIETE_ID: string;
    ASSIGNATIONS: Model_TeamAssignationAgent[];
}

export class Model_Release {
    ID: string;
    NOM_RELEASE: string;
    APP_VERSION_CODE: string;
    APP_VERSION_DISPLAY: string;
    DATE_CREATION?: Date;
    DATE_MODIFICATION?: Date;
    DATE_SUPPRESSION?: Date;
    SOMMEIL: boolean;
    IS_PUBLISH: boolean;
    APP_FICHIER: string;
    RELEASE_NOTE: string;
    TAILLE_FICHIER: number;
    SOCIETE_ID: string;
    COED_SOCIETE: string;
    DATE_DEBUT_PUBLICATION?: Date;
    DATE_FIN_PUBLICATION?: Date;
}

export class ReleaseSaveRequestDTO {
    ID: string;
    NOM_RELEASE: string;
    APP_VERSION_CODE: string;
    APP_VERSION_DISPLAY: string;
    SOCIETE_ID: string;
}

export class BaseQueryParams {
    protected _maxPageSize: number = 500;
    protected _pageSize: number = 10;
    PaginationEnabled: boolean = false;
    PageNumber: number = 1;
    OrderByColumn: string = "ID";
    OrderByDirection: string = "DESC";
    DateDebut?: Date;
    DateFin?: Date;
    IDS: number[];
    SearchValue: string = '';
    SOMMEIL_FILTER = -1;

    public get PageSize(): number{
        return this._pageSize;
    }

    public set PageSize(value: number) {
        this._pageSize = (value > this._maxPageSize) ? this._maxPageSize : value;
    }
}

export class AuthenticatedDTO {
    User: Model_Agent;
    AccessToken: string;
    RefreshToken: string;
}

export const SOMMEIL_FILTER_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: -1, mDISPLAY_MEMBER: "Tous" },
    { mVALUE_MEMBER: 1, mDISPLAY_MEMBER: "Actif" },
    { mVALUE_MEMBER: 0, mDISPLAY_MEMBER: "Inactif" }
];

export enum ROLE_USER {
    ADMIN = 1,
    USER = 2,
    ADMIN_WORKSPACE = 3,
    AGENT = 4
}

export const ROLE_USER_LABELS: {[key: string]: string} = {
    '1': 'Super Administrateur',
    '2': 'Manager',
    '3': 'Administrateur',
    '4': 'Agent'
}

export class AbsGrid<T> {
    mAbsColumns: AbsColumn[];
    mColumns: string[];
    mColumnNames: string[];
    mData: T[] = [];
    mGroups?: any[] = [];
  
    constructor() {
      this.mAbsColumns = [];
      this.mColumns = [];
      this.mColumnNames = [];
      this.mData = [];
    }
}

export class PaginatedResults<T> {
    mDatas: T[] = [];
    mCountTotal: number;
    mPageSize: number;
    mPageNumber: number;
    mTotalPages: number;

    constructor() {
        this.mDatas = [];
        this.mCountTotal = 0;
        this.mPageSize = 0;
        this.mPageNumber = 0;
        this.mTotalPages = 0;
    }
}

export class AbsPaginatedGrid<T> {
    mAbsColumns: AbsColumn[];
    mColumns: string[];
    mColumnNames: string[];
    mPagination: PaginatedResults<T>;
    mTotalDatas: number;

    constructor() {
        this.mAbsColumns = [];
        this.mColumns = [];
        this.mColumnNames = [];
        this.mPagination = new PaginatedResults();
        this.mTotalDatas = 0;
    }
}

export class AbsColumn {
    mDatasource: string;
    mTitle: string;
    mType: TYPE_COLONNE;
    mTypeDonnees: TYPE_DONNEE;
    mVisible: boolean;
    mTemplate?: string;
    mHasCustomHtml: boolean;
    width?: number;
    paramsColumn?: any;
}

export enum TYPE_TEAM_ASSIGNATION {
    AGENT = 1,
    SUPERVISEUR
}

export enum TYPE_COLONNE {
    DIMENSION = 0,
    VALEUR = 1,
    VIRTUEL = 2
}

export enum TYPE_DONNEE {
    NUMERIQUE = 0,
    STRING = 1,
    DATETIME = 2,
    NUMERIQUE_POIDS = 3,
    NUMERIQUE_TEMPS = 4,
    NUMERIQUE_MONTANT = 5,
    BOOLEAN = 6,
    DATE = 7
}
export enum INSTALLATION_STATUS_SOCIETE {
    ALL = -1,
    DESACTIVE = 0,
    NON_INSTALLE = 1,
    INSTALLATION_EN_COURS = 2,
    INSTALLE = 3,
    MISE_A_JOUR_DISPONIBLE = 4,
    MISE_A_JOUR_EN_COURS = 5,
}

export enum SQL_TYPE_AUTHENTIFICATION {
    SQL_SERVER = 1,
    WINDOWS = 2
}

export class AbsDSOptionsItems {
    mVALUE_MEMBER: any;
    mDISPLAY_MEMBER: string; 
}

export class LiveNotification {
    TYPE_LIVE_NOTIFICATION: TYPE_LIVE_NOTIFICATION;
    NOTIFICATION_DATAS: any;
    ID?: string;
    MESSAGE?: string;
    SHOW_NOTIFICATION?: boolean;
}

export enum TYPE_LIVE_NOTIFICATION {
    PERIPHERIQUE_NEW_REGISTRATION_REQUEST = 1,
    PERIPHERIQUE_CONNECTED_DEVICES = 2,
    PUSH_MESSAGE = 3,
    PERIPHERIQUE_NEW_ASSIGNATION = 4,
    WORKFLOW_EXECUTION = 5,
    LOG_INFO = 6,
    RUNNER_TASK_UPDATED = 7,
    RUNNER_CONNECTED = 8,
    RUNNER_DISCONNECTED = 9,
    NEW_WORKFLOW_INSTANTIATED = 10
}
// #endregion

export class Model_VariableEnvironnement {
    ID: string;
    NOM_VARIABLE: string;
    LIBELLE_VARIABLE: string;
    DESCRIPTION_VARIABLE: string;
    TYPE_VARIABLE: TYPE_VARIABLE_ENVIRONMENT;
    DEFAULT_VALEUR_VARIABLE: string;
    SCOPE_VARIABLE: SCOPE_VARIABLE_ENVIRONMENT;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    IS_CORE_VARIABLE: boolean;
}

export enum TYPE_VARIABLE_ENVIRONMENT {
    ALL = -1,
    TEXT = 0,
    NUMBER = 1,
    DATETIME = 2,
    NUMBER_CURRENCY = 3,

}

export enum SCOPE_VARIABLE_ENVIRONMENT {
    ALL = -1,
    PRIVATE = 0,
    PUBLIC = 1
}

export class Model_VariableEnvironnementUser {
    ID: string;
    NOM_VARIABLE: string;
    VALEUR_VARIABLE: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    VARIABLE_ENVIRONNEMENT_ID: string;
    AGENT_ID: string;
    VARIABLE_ENVIRONNEMENT: Model_VariableEnvironnement;
    IS_CORE_VARIABLE: boolean;
    SYNCED: boolean;
    DATE_SYNCHRONISATION: string;
    AGENT: Model_Agent;
}

export enum TYPE_DATASOURCE {
    ALL = -1,
    STATIC = 0,
    TABLE_RUNNER = 1,
    SQL_VIEW = 2,
    WORKFLOWS = 3,
    JSON = 4,
}

export const TYPE_DATASOURCE_LABELS: {[key: number]: string} = {
    0: 'Statique',
    1: "Table Runner",
    2: "Vue SQL",
    3: "Workflow",
    4: "JSON",
}

export class AbwDatasourceJointure {
    FK_COLUMN: string;
    NUM_DATASOURCE: string;
    JOIN_COLUMN: string;
}

export class AbwDatasourceParameter {
    NAME: string;
    LABEL: string;
    TYPE_DEFAULT_VALUE: TYPE_DEFAULT_VALUE;
    DEFAULT_VALUE?: string;
}

export class AbwDatasourceFilter {
    FilterColumn: string;
    FilterOperator: 'eq' | 'gt' | 'lt' | 'gte' | 'lte' | 'ne' | 'contains' | 'not_contains' | 'is_empty' | 'not_empty' | 'start_with' | 'end_with';
    FilterValue: string;
}

export class AbwDatasourceOrder {
    OrderColumn: string;
    OrderDirection: 'ASC' | 'DESC';
}

export class AbwDatasourceColumn {
    name: string;
    typeColumn: TYPE_COLONNE;
    typeDonnees: TYPE_DONNEE;
    label?: string;
    sourceColumn: SOURCE_COLONNE;
    numDatasource: string;
    paramsColumn?: any;
}

export enum SOURCE_COLONNE {
    DATASOURCE = 0,
    JOINTURE = 1
}

export class Model_Datasource {
    ID: string;
    GUID_SYNCHRONISATION: string;
    NUM_DATASOURCE: string;
    TYPE_DATASOURCE: TYPE_DATASOURCE;
    TITRE: string;
    DESCRIPTION: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    IS_LOCKED: boolean;
    DS_PARAMS: AbwDatasourceParams;
    SYNCED: boolean;
    DATE_SYNCHRONISATION: string;
    GUID_CACHE: string;

    datas?: AbsPaginatedGrid<any>;
}

export class AbwDatasourceParams {
    name: string;
    datas: any[];
    DS_COLUMNS: AbwDatasourceColumn[];
    DS_FILTERS: AbwDatasourceFilter[];
    DS_ORDERS: AbwDatasourceOrder[];
    DS_JOINTURES: AbwDatasourceJointure[];
    DS_PARAMETERS: AbwDatasourceParameter[];
    rawDatas: any;
}

export enum TYPE_DATASOURCE_PROVIDER_ITEM {
    STRUCTURE = 1,
    DOCUMENT = 2
}

export class AbwDatasourceProviderItem {
    name: string;
    type: TYPE_DATASOURCE_PROVIDER_ITEM;
    columns: AbwDatasourceColumn[];
    label?: string;
}

export enum TYPE_DEFAULT_VALUE {
    CONSTANT = 1,
    COMPUTED = 2,
    ENVIRONMENT_VARIABLE = 3,
    WORKFLOW_FIELD = 4,
    FONCTION = 5,
    
    WORKFLOW_GRID_FIELD = 6,
}

export class StartupInfos_Datasource {
    datasourceProviders: {[key: number]: AbwDatasourceProviderItem[]} = {};
    datasources: Model_Datasource[] = [];
}

export const TYPE_DATASOURCE_FILTER_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_DATASOURCE.ALL, mDISPLAY_MEMBER: "Tous" },
    { mVALUE_MEMBER: TYPE_DATASOURCE.WORKFLOWS, mDISPLAY_MEMBER: "Workflows" },
    { mVALUE_MEMBER: TYPE_DATASOURCE.STATIC, mDISPLAY_MEMBER: "Statique" },
    { mVALUE_MEMBER: TYPE_DATASOURCE.TABLE_RUNNER, mDISPLAY_MEMBER: "Table Runner" },
    { mVALUE_MEMBER: TYPE_DATASOURCE.SQL_VIEW, mDISPLAY_MEMBER: "Vue SQL" },
    { mVALUE_MEMBER: TYPE_DATASOURCE.JSON, mDISPLAY_MEMBER: "JSON" },
];

export const DATASOURCE_COLUMN_TYPES_OPTION: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_COLONNE.DIMENSION, mDISPLAY_MEMBER: "Dimension" },
    { mVALUE_MEMBER: TYPE_COLONNE.VALEUR, mDISPLAY_MEMBER: "Valeur" },
];

export const DATASOURCE_COLUMN_TYPES_DONNEES_OPTION: {mVALUE_MEMBER: any, mDISPLAY_MEMBER: string, COLUMN_TYPES: TYPE_COLONNE[] }[] = [
    { mVALUE_MEMBER: TYPE_DONNEE.STRING, mDISPLAY_MEMBER: "Texte", COLUMN_TYPES: [TYPE_COLONNE.DIMENSION] },
    { mVALUE_MEMBER: TYPE_DONNEE.NUMERIQUE, mDISPLAY_MEMBER: "Numérique", COLUMN_TYPES: [TYPE_COLONNE.DIMENSION, TYPE_COLONNE.VALEUR] },
    { mVALUE_MEMBER: TYPE_DONNEE.NUMERIQUE_MONTANT, mDISPLAY_MEMBER: "Montant", COLUMN_TYPES: [TYPE_COLONNE.VALEUR] },
    { mVALUE_MEMBER: TYPE_DONNEE.DATETIME, mDISPLAY_MEMBER: "Date & Heure", COLUMN_TYPES: [TYPE_COLONNE.DIMENSION] },
    { mVALUE_MEMBER: TYPE_DONNEE.BOOLEAN, mDISPLAY_MEMBER: "Booléen", COLUMN_TYPES: [TYPE_COLONNE.DIMENSION] },
];

export class Model_Workflow {
    ID: string;
    NUM_WORKFLOW: string;
    TITRE: string;
    DESCRIPTION: string;
    CAN_RUN_OFFLINE: boolean;
    CAN_RUN_CONTINUOUSLY: boolean;
    TITRE_EXECUTION_EXPRESSION: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    USER_ID: string;
    IS_LOCKED: boolean;
    CATALOGUE_ID: string;
    AGENT: Model_Agent;

    WORKFLOW_STEPS: Model_WorkflowStep[];
}

export class Model_WorkflowStep {
    ID: string;
    NUM_WORKFLOW: string;
    NUM_WORKFLOWSTEP: string;
    INDEX_WORKFLOWSTEP: number;
    TITRE: string;
    DESCRIPTION: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    IS_EDITABLE: boolean;
    IS_PAUSABLE: boolean;
    USER_ID: string;
    TYPE_GEOLOCALISATION: TYPE_GEOLOCALISATION;

    COMPONENTS: Model_WorkflowComponent[];
    DECLENCHEURS?: Model_Declencheur[];
}

export class Model_WorkflowComponent {
    ID: string;
    INDEX?: number;
    GUID?: string;
    CODE: CODE_WORKFLOW_COMPONENT;
    ICON?: string;
    LABEL: string;
    UIC_PARAMS?: any;
    TYPE_DEFAULT_VALUE?: TYPE_DEFAULT_VALUE;
    DEFAULT_VALUE?: any;
    RESPONSE_VALUE?: any;
    DEFAULT_VALUE_EXPRESSION?: string;
    DEFAULT_VALUE_WORKFLOW_COMPONENT_ID?: any;
    DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY?: string;
    TYPE_DEFAULT_VALUE_FUNCTION_ID?: FONCTION_WORKFLOW_COMPONENT;
    IS_VISIBLE?: boolean;
    IS_REQUIRED?: boolean;
    IS_READONLY?: boolean;
    HAS_DATASOURCE?: boolean;
    DATASOURCES_INFOS?: any[];
    COMPONENT_RESULT?: RESULT_WORKFLOW_COMPONENT;
    CUSTOM_VALIDATORS?: any;
    PROPERTIES?: Model_WorkflowComponent[];
    COMPONENT_MODE?: COMPONENT_MODE;
    NUM_DATASOURCE?: any;
    RELATIONS?: any[];
    VALUE_COLUMN_NAME?: string;
    DISPLAY_COLUMN_NAME?: string;
    CONDITIONS_VISIBILITY?: Expression;
    CONDITIONS_ENABLED?: Expression;
    CONDITIONS_REQUIRED?: Expression;
    CONDITIONS_VALIDITION?: Expression;
    CONDITIONS_FORMATTING?: any;
    GRID_COLUMNS?: Model_WorkflowComponent[];
    FORM_ID?: string;
    NUMBER_FORMAT?: FORMAT_NUMBER;

    WORKFLOW_STEP?: Model_WorkflowStep;
    CODE_SOCIETE?: string;
    IS_ROWS_EDITABLE?: boolean;
    IS_ROWS_DELETABLE?: boolean;

    INPUT_GRID_FUNCTION_ID?: string;
    INPUT_GRID_FILTERS?: any;

    PARENT_GRID_INPUT_ID?: string;

    ROWS?: number;

    INPUT_TYPE?: string;

    HAS_DATASOURCE_FILTERS?: boolean;
    HAS_CACHE_OPTION?: boolean;

    BH_MODE_SELECTION_SITE?: any;
}

export enum RESULT_WORKFLOW_COMPONENT {
    SIMPLE_DATA = 'SIMPLE_DATA',
    JSON_OBJECT = 'JSON_OBJECT',
    JSON_ARRAY = 'JSON_ARRAY',
    BINARY_FILE = 'BINARY_FILE'
}

export enum CODE_WORKFLOW_COMPONENT {
    LABEL = 'LABEL',
    TEXTBOX = 'TEXTBOX',
    NUMERIC_TEXTBOX = 'NUMERIC_TEXTBOX',
    TEXTAREA = 'TEXTAREA',
    DATEPICKER = 'DATEPICKER',
    DROPDOWN = 'DROPDOWN',
    TOGGLE = 'TOGGLE',
    DATASOURCE_PICKER = 'DATASOURCE_PICKER',
    CHECKBOX = 'CHECKBOX',
    RADIOBOX = 'RADIOBOX',
    ELECTRONIC_SIGNATURE = 'ELECTRONIC_SIGNATURE',
    SCAN_QRCODE = 'SCAN_QRCODE',
    SCAN_DOCUMENT = 'SCAN_DOCUMENT',
    UPLOAD_FILE = 'UPLOAD_FILE',
    CAMERA = 'CAMERA',
    INPUT_GRID = 'INPUT_GRID',
    INPUT_GRID_COLUMNS_BUILDER = 'INPUT_GRID_COLUMNS_BUILDER',
    INPUT_GRID_COLUMNS_DATASOURCE_MAPPING = 'INPUT_GRID_COLUMNS_DATASOURCE_MAPPING',
    INPUT_GRID_FUNCTIONS = 'INPUT_GRID_FUNCTIONS',
    INPUT_GRID_FILTERS = 'INPUT_GRID_FILTERS',
    FAMOCO_SCAN_LASER = 'FAMOCO_SCAN_LASER',
    EXPRESSION_BUILDER = 'EXPRESSION_BUILDER',
    EXPRESSION_EVALUATOR = 'EXPRESSION_EVALUATOR',
    CHIPS_INPUT = 'CHIPS_INPUT',
    RICH_AUTOCOMPLETE = 'RICH_AUTOCOMPLETE',
    GED = 'GED',
    GED_DESIGNER = 'GED_DESIGNER',
    SOUDOTEC_BARCODES_VERIFICATION = 'SOUDOTEC_BARCODES_VERIFICATION',
    SOUDOTEC_COMMAND_GRIDINPUT = 'SOUDOTEC_COMMAND_GRIDINPUT',
    SOUDOTEC_INVENTORY_INPUT = 'SOUDOTEC_INVENTORY_INPUT',
    SOUDOTEC_RECEPTION_MARCHANDISE = 'SOUDOTEC_RECEPTION_MARCHANDISE',
    MIBEM_COMMAND_INPUT = 'MIBEM_COMMAND_INPUT',
    DATASOURCE_DATAS_SELECTION = 'DATASOURCE_DATAS_SELECTION',
    NEWLAND_SCANNER = 'NEWLAND_SCANNER',
    BE_RETAIL_INVENTORY_INPUT = 'BE_RETAIL_INVENTORY_INPUT',
    AGENDA_PLANNER = 'AGENDA_PLANNER',
    BLACK_HAWK_SCAN_QRCODE = 'BLACK_HAWK_SCAN_QRCODE',
    BLACK_HAWK_SCAN_QRCODE_SITE = 'BLACK_HAWK_SCAN_QRCODE_SITE',
    MULTIPACK_COMMERCIAL_PLANNING = 'MULTIPACK_COMMERCIAL_PLANNING',
    KANBAN = 'KANBAN',
    SOUDOTEC_ITEMS_INPUT = 'SOUDOTEC_ITEMS_INPUT',
    SOUDOTEC_EMPLACEMENT_INPUT = 'SOUDOTEC_EMPLACEMENT_INPUT'
}

export enum FONCTION_WORKFLOW_COMPONENT {
    ID_AGENT = '_ID_AGENT_',
    NOM_AGENT = '_NOM_AGENT_',
    PRENOMS_AGENT = '_PRENOMS_AGENT_',
    EMAIL_AGENT = '_EMAIL_AGENT_',
    USERNAME_AGENT = '_USERNAME_AGENT_',
    ID_EXECUTION_WORKFLOW = '_ID_EXECUTION_WORKFLOW_',
    DATE_EXECUTION_WORKFLOW = '_DATE_EXECUTION_WORKFLOW_',
    STATUS_EXECUTION_WORKFLOW = '_STATUS_EXECUTION_WORKFLOW_',
    ROW_INDEX = '_ROW_INDEX_',
    GUID = '_GUID_',
}

export const FONCTION_WORKFLOW_COMPONENT_LABELS: {[key: string]: string} = {
    '_ID_AGENT_': 'Identifiant [Agent]',
    '_NOM_AGENT_': 'Nom [Agent]',
    '_PRENOMS_AGENT_': "Prénoms [Agent]",
    '_EMAIL_AGENT_': "Adresse email [Agent]",
    '_USERNAME_AGENT_': "Nom d\'utilisateur [Agent]",
    '_ID_EXECUTION_WORKFLOW_': "ID execution [Workflow]",
    '_DATE_EXECUTION_WORKFLOW_': "Date execution [Workflow]",
    '_STATUS_EXECUTION_WORKFLOW_': "Status execution [Workflow]",
    '_ROW_INDEX_': "Numéro de ligne",
    '_GUID_': "Identifiant généré (36 caractères)",
}

export const FONCTION_WORKFLOW_COMPONENT_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: FONCTION_WORKFLOW_COMPONENT.ID_AGENT, mDISPLAY_MEMBER: FONCTION_WORKFLOW_COMPONENT_LABELS[FONCTION_WORKFLOW_COMPONENT.ID_AGENT] },
    { mVALUE_MEMBER: FONCTION_WORKFLOW_COMPONENT.NOM_AGENT, mDISPLAY_MEMBER: FONCTION_WORKFLOW_COMPONENT_LABELS[FONCTION_WORKFLOW_COMPONENT.NOM_AGENT] },
    { mVALUE_MEMBER: FONCTION_WORKFLOW_COMPONENT.PRENOMS_AGENT, mDISPLAY_MEMBER: FONCTION_WORKFLOW_COMPONENT_LABELS[FONCTION_WORKFLOW_COMPONENT.PRENOMS_AGENT] },
    { mVALUE_MEMBER: FONCTION_WORKFLOW_COMPONENT.EMAIL_AGENT, mDISPLAY_MEMBER: FONCTION_WORKFLOW_COMPONENT_LABELS[FONCTION_WORKFLOW_COMPONENT.EMAIL_AGENT] },
    { mVALUE_MEMBER: FONCTION_WORKFLOW_COMPONENT.USERNAME_AGENT, mDISPLAY_MEMBER: FONCTION_WORKFLOW_COMPONENT_LABELS[FONCTION_WORKFLOW_COMPONENT.USERNAME_AGENT] },
    { mVALUE_MEMBER: FONCTION_WORKFLOW_COMPONENT.DATE_EXECUTION_WORKFLOW, mDISPLAY_MEMBER: FONCTION_WORKFLOW_COMPONENT_LABELS[FONCTION_WORKFLOW_COMPONENT.DATE_EXECUTION_WORKFLOW] },
    { mVALUE_MEMBER: FONCTION_WORKFLOW_COMPONENT.ROW_INDEX, mDISPLAY_MEMBER: FONCTION_WORKFLOW_COMPONENT_LABELS[FONCTION_WORKFLOW_COMPONENT.ROW_INDEX] },
    { mVALUE_MEMBER: FONCTION_WORKFLOW_COMPONENT.GUID, mDISPLAY_MEMBER: FONCTION_WORKFLOW_COMPONENT_LABELS[FONCTION_WORKFLOW_COMPONENT.GUID] },
];

export class WorkflowComponentObserver {
    field: string; 
    type: TYPE_WORKFLOW_COMPONENT_OBSERVER;
    params: any;
    formId?: string;
}

export enum TYPE_WORKFLOW_COMPONENT_OBSERVER {
    OBSERVE_DATASOURCE_STRUCTURE = 'OBSERVE_DATASOURCE_STRUCTURE',
    OBSERVER_VALUE = 'OBSERVER_VALUE',
    FILTER_DATASOURCE = 'FILTER_DATASOURCE',
    ASSIGN_WORKFLOW_COMPONENT_DATAS = 'ASSIGN_WORKFLOW_COMPONENT_DATAS',
    ASSIGN_GRID_COLUMNS = 'ASSIGN_GRID_COLUMNS',
    LIST_GRID_COLUMNS = 'LIST_GRID_COLUMNS',
    OBSERVER_GRID_VALUE = 'OBSERVER_GRID_VALUE',
}

export enum TYPE_COMPONENT_CONDITIONS {
    CONDITION_VISIBILITY = 'CONDITION_VISIBILITY',
    CONDITION_ENABLED = 'CONDITION_ENABLED',
    CONDITION_REQUIRED = 'CONDITION_REQUIRED',
    CONDITION_VALIDATION = 'CONDITION_VALIDATION'
}

export class Expression {
    condition?: 'and' | 'or';
    rules?: Expression[];
    field?: string;
    operator?: string;
    scope?: EXPRESSION_FIELD_SCOPE;
    value?: any;
    datasource_column?: string;
}

export enum EXPRESSION_FIELD_SCOPE {
  CONSTANT = 'CONSTANT',
  WORKFLOW_COMPONENT = 'WORKFLOW_COMPONENT',
  VARIABLE_ENVIRONNEMENT = 'VARIABLE_ENVIRONNEMENT',
  DATASOURCE = 'DATASOURCE',
  WORKFLOW_COMPONENT_METADATA = 'WORKFLOW_COMPONENT_METADATA'
}

export enum TYPE_DECLENCHEUR {
    ALL = -1,
    SEND_NOTIFICATION = 0,
    ACTION_VARIABLE = 1,
    ACTION_DATASOURCE = 2,
    INSTANTIATE_WORKFLOW = 3,
    PRINT_DOCUMENT = 4,
    RUNNER_JOB = 5,
    ACTION_DATASOURCE_FROM_INPUT_GRID = 6,
    PRINT_TICKET = 7,
    CANCEL_WORKFLOW_EXECUTION = 8,
    BLHAWK_ACTION_DATASOURCE_FROM_AGENDA_PLANNER = 9,
    MULTIPACK_ACTION_DATASOURCE_FROM_COMMERCIAL_PLANNING = 10,
    SAVE_DOCUMENT_PDF = 11,
    ACTION_DATASOURCE_FROM_KANBAN = 12,
    SYNC_KANBAN_DATAS_WITH_DATASOURCE = 13,
    ACTION_CHECK_SAGE_EMPLACEMENT = 14,
    BLACK_HAWK_UPDATE_AGENTS_STATUSES_FROM_CONTROLE = 15,
}

export const TYPE_DECLENCHEUR_LABELS: {[key: number]: string} = {
    0: 'Notification',
    1: "Mise à jour de variable d'environnement",
    2: "Mise à jour de source de données à partir des champs du workflow",
    3: "Démarrer workflow",
    4: "Imprimer un document",
    5: "Déclencher un job runner",
    6: "Mise à jour de source de données à partir d'une grille de saisie",
    7: "Imprimer un ticket",
    8: "Annuler une execution de workflow",
    9: "[BLACKHAWK] - Mise à jour de source de données à partir d'un planificateur",
    10: "[MULTIPACK] - Mise à jour de source de données à partir d'un planificateur",
    11: "Enregistrer un document PDF",
    12: "Mise à jour de source de données à partir d'un kanban",
    13: "Synchroniser les données kanban avec une source de données",
    14: "Vérification d'un emplacement Sage",
    15: "[BLACKHAWK] - Mise à jour des status des agents à partir d'un controle d'agents",
}

export const TYPE_DECLENCHEUR_OPTIONS: { mVALUE_MEMBER: any, mDISPLAY_MEMBER: string, CODE_SOCIETE?: string }[] = [
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.ALL, mDISPLAY_MEMBER: "Sélectionnez un type" },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.SEND_NOTIFICATION, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.SEND_NOTIFICATION] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.ACTION_VARIABLE, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.ACTION_VARIABLE] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.ACTION_DATASOURCE, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.ACTION_DATASOURCE] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.ACTION_DATASOURCE_FROM_INPUT_GRID, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.ACTION_DATASOURCE_FROM_INPUT_GRID] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.ACTION_DATASOURCE_FROM_KANBAN, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.ACTION_DATASOURCE_FROM_KANBAN] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.SYNC_KANBAN_DATAS_WITH_DATASOURCE, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.SYNC_KANBAN_DATAS_WITH_DATASOURCE] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.INSTANTIATE_WORKFLOW, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.INSTANTIATE_WORKFLOW] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.PRINT_DOCUMENT, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.PRINT_DOCUMENT] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.SAVE_DOCUMENT_PDF, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.SAVE_DOCUMENT_PDF] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.RUNNER_JOB, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.RUNNER_JOB] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.PRINT_TICKET, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.PRINT_TICKET] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.CANCEL_WORKFLOW_EXECUTION, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.CANCEL_WORKFLOW_EXECUTION] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.BLHAWK_ACTION_DATASOURCE_FROM_AGENDA_PLANNER, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.BLHAWK_ACTION_DATASOURCE_FROM_AGENDA_PLANNER], CODE_SOCIETE: 'BLACK_HAWK_SECURITY' },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.MULTIPACK_ACTION_DATASOURCE_FROM_COMMERCIAL_PLANNING, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.MULTIPACK_ACTION_DATASOURCE_FROM_COMMERCIAL_PLANNING], CODE_SOCIETE: 'MULTIPACK' },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.ACTION_CHECK_SAGE_EMPLACEMENT, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.ACTION_CHECK_SAGE_EMPLACEMENT] },
    { mVALUE_MEMBER: TYPE_DECLENCHEUR.BLACK_HAWK_UPDATE_AGENTS_STATUSES_FROM_CONTROLE, mDISPLAY_MEMBER: TYPE_DECLENCHEUR_LABELS[TYPE_DECLENCHEUR.BLACK_HAWK_UPDATE_AGENTS_STATUSES_FROM_CONTROLE] },
];

export enum EVENT_DECLENCHEUR {
    ALL = -1,
    START_OF_WORKFLOW_STEP = 0,
    END_OF_WORKFLOW_STEP = 1,
    END_OF_SYNCHRONISATION = 2,
}

export const EVENT_DECLENCHEUR_LABELS: {[key: number]: string} = {
    0: "Début Etape Workflow",
    1: "Fin Etape Workflow",
    2: "Fin Synchronisation",
}

export const EVENT_DECLENCHEUR_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: EVENT_DECLENCHEUR.ALL, mDISPLAY_MEMBER: "Sélectionnez un évènement" },
    { mVALUE_MEMBER: EVENT_DECLENCHEUR.START_OF_WORKFLOW_STEP, mDISPLAY_MEMBER: EVENT_DECLENCHEUR_LABELS[EVENT_DECLENCHEUR.START_OF_WORKFLOW_STEP] },
    { mVALUE_MEMBER: EVENT_DECLENCHEUR.END_OF_WORKFLOW_STEP, mDISPLAY_MEMBER: EVENT_DECLENCHEUR_LABELS[EVENT_DECLENCHEUR.END_OF_WORKFLOW_STEP] },
    { mVALUE_MEMBER: EVENT_DECLENCHEUR.END_OF_SYNCHRONISATION, mDISPLAY_MEMBER: EVENT_DECLENCHEUR_LABELS[EVENT_DECLENCHEUR.END_OF_SYNCHRONISATION] },
];

export enum TYPE_NOTIFICATION_DECLENCHEUR {
    ALL = -1,
    NOTIFICATION_PUSH = 0,
    NOTIFICATION_SMS = 1,
    NOTIFICATION_EMAIL = 2
}

export const TYPE_NOTIFICATION_DECLENCHEUR_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_NOTIFICATION_DECLENCHEUR.ALL, mDISPLAY_MEMBER: "Sélectionnez un type de notification" },
    { mVALUE_MEMBER: TYPE_NOTIFICATION_DECLENCHEUR.NOTIFICATION_PUSH, mDISPLAY_MEMBER: "Notification Push" },
    //{ mVALUE_MEMBER: TYPE_NOTIFICATION_DECLENCHEUR.NOTIFICATION_SMS, mDISPLAY_MEMBER: "Notification SMS" },
    //{ mVALUE_MEMBER: TYPE_NOTIFICATION_DECLENCHEUR.NOTIFICATION_EMAIL, mDISPLAY_MEMBER: "Notification Email" },
];

export enum TYPE_DESTINATAIRES_DECLENCHEUR {
    ALL = -1,
    AGENT = 0,
    WORKFLOW_COMPONENT = 1,
    CONSTANT = 2
}

export const TYPE_DESTINATAIRES_DECLENCHEUR_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_DESTINATAIRES_DECLENCHEUR.ALL, mDISPLAY_MEMBER: "Sélectionnez un type de destinataire" },
    { mVALUE_MEMBER: TYPE_DESTINATAIRES_DECLENCHEUR.AGENT, mDISPLAY_MEMBER: "Agent" },
    { mVALUE_MEMBER: TYPE_DESTINATAIRES_DECLENCHEUR.WORKFLOW_COMPONENT, mDISPLAY_MEMBER: "Champ du workflow" },
    { mVALUE_MEMBER: TYPE_DESTINATAIRES_DECLENCHEUR.CONSTANT, mDISPLAY_MEMBER: "Personnalisé" },
];

export enum TYPE_ACTION_DATASOURCE_DECLENCHEUR {
    ALL = -1,
    INSERT = 0,
    UPDATE = 1,
    DELETE = 2
}

export const TYPE_ACTION_DATASOURCE_DECLENCHEUR_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_ACTION_DATASOURCE_DECLENCHEUR.ALL, mDISPLAY_MEMBER: "Sélectionnez une action" },
    { mVALUE_MEMBER: TYPE_ACTION_DATASOURCE_DECLENCHEUR.INSERT, mDISPLAY_MEMBER: "Ajout" },
    { mVALUE_MEMBER: TYPE_ACTION_DATASOURCE_DECLENCHEUR.UPDATE, mDISPLAY_MEMBER: "Modification" },
    //{ mVALUE_MEMBER: TYPE_ACTION_DATASOURCE_DECLENCHEUR.DELETE, mDISPLAY_MEMBER: "Suppression" },
];

export class Model_Declencheur {
    ID: string;
    TYPE_DECLENCHEUR: TYPE_DECLENCHEUR;
    EVENT_DECLENCHEUR: EVENT_DECLENCHEUR;
    PARAMS_DECLENCHEUR: Model_DeclencheurWorkflowParams;
    CONDITIONS_DECLENCHEUR?: Expression;
    DATE_CREATION: string;
    DATE_MODIICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    USER_ID: string;
    NUM_WORKFLOW: string;
    NUM_WORKFLOWSTEP: string;
}

export class Model_DeclencheurWorkflowParams {
    NUM_WORKFLOW: string;
    NUM_WORKFLOWSTEP: string;
    ACTION_NOTIFICATION_OPTIONS: Model_DeclencheurActionNotificationOptions;
    ACTION_VARIABLE_ENVIRONNEMENT_OPTIONS: Model_DeclencheurActionVariableEnvironnementOptions;
    ACTION_DATASOURCE_OPTIONS: Model_DeclencheurActionDatasourceOptions;
    ACTION_DATASOURCE_FROM_INPUT_GRID_OPTIONS: Model_DeclencheurActionDatasourceFromInputGridOptions;
    ACTION_DATASOURCE_FROM_KANBAN_OPTIONS: Model_DeclencheurActionDatasourceFromKanbanOptions;
    ACTION_SYNC_KANBAN_DATAS_WITH_DATASOURCE_OPTIONS: Model_DeclencheurActionSyncKanbanDatasWithDatasourceOptions;
    ACTION_INSTANTIATE_WORKFLOW_OPTIONS: Model_DeclencheurActionInstantiateWorkflowOptions;
    ACTION_PRINT_DOCUMENT_OPTIONS: Model_DeclencheurActionPrintDocumentOptions;
    ACTION_SAVE_DOCUMENT_PDF_OPTIONS: Model_DeclencheurActionSaveDocumentPdfOptions;
    ACTION_RUNNER_JOB_OPTIONS: Model_DeclencheurActionRunnerJobOptions;
    ACTION_PRINT_TICKET_OPTIONS: Model_DeclencheurActionPrintTicketOptions;
    ACTION_CANCEL_EXECUTION_WORKFLOW_OPTIONS: Model_DeclencheurActionCancelExecutionWorkflowOptions;
    ACTION_DATASOURCE_FROM_INPUT_AGENDA_PLANNER_OPTIONS: Model_DeclencheurActionDatasourceFromInputAgendaPlannerOptions;
    ACTION_DATASOURCE_FROM_MULTIPACK_INPUT_AGENDA_PLANNER_OPTIONS: Model_DeclencheurActionDatasourceFromMultipackInputAgendaPlannerOptions;
    ACTION_CHECK_SAGE_EMPLACEMENT_OPTIONS: Model_DeclencheurActionCheckSageEmplacementOptions;
    BLACK_HAWK_UPDATE_AGENTS_STATUSES_FROM_CONTROLE_OPTIONS: Model_DeclencheurUpdateAgentsStatusesFromControleOptions;
}

export class Model_DeclencheurActionRunnerJobOptions {
    TYPE_RUNNER_TASK_ID: TYPE_RUNNER_TASK_ID;
}

export class Model_DeclencheurActionNotificationOptions {
    TYPE_NOTIFICATION: TYPE_NOTIFICATION_DECLENCHEUR;
    TYPE_DESTINATAIRES_NOTIFICATION: TYPE_DESTINATAIRES_DECLENCHEUR;
    DESTINATAIRES_AGENT_NOTIFICATION: any;
    DESTINATAIRES_WORKFLOW_COMPONENT_NOTIFICATION: any;
    DESTINATAIRES_NOTIFICATION: any;
    CONTENU_NOTIFICATION: string;
}

export class Model_DeclencheurActionVariableEnvironnementOptions {
    NOM_VARIABLE: string;
    TYPE_DEFAULT_VALUE: TYPE_DEFAULT_VALUE;
    CONSTANT_VALUE_VARIABLE_ENVIRONNEMENT: any;
    EXPRESSION_VARIABLE_ENVIRONNEMENT: any;
    WORKFLOW_COMPONENT_VARIABLE_ENVIRONNEMENT: any;
}

export class Model_DeclencheurActionDatasourceOptions {
    NUM_DATASOURCE: string;
    TYPE_ACTION_DATASOURCE: TYPE_ACTION_DATASOURCE_DECLENCHEUR;
    UPDATE_DATAS_IF_EXISTS: boolean;
    PRIMARY_KEY_DATASOURCE: string;
    COLUMNS_MAPPING: Model_DeclencheurColumnMapping[];
}

export class Model_DeclencheurActionDatasourceFromInputGridOptions {
    NUM_DATASOURCE: string;
    INPUT_GRID_ID: string;
    TYPE_ACTION_DATASOURCE: TYPE_ACTION_DATASOURCE_DECLENCHEUR;
    UPDATE_DATAS_IF_EXISTS: boolean;
    PRIMARY_KEY_DATASOURCE: string;
    COLUMNS_MAPPING: Model_DeclencheurColumnMapping[];
}

export class Model_DeclencheurActionDatasourceFromKanbanOptions {
    NUM_DATASOURCE: string;
    KANBAN_ID: string;
    TYPE_ACTION_DATASOURCE: TYPE_ACTION_DATASOURCE_DECLENCHEUR;
    UPDATE_DATAS_IF_EXISTS: boolean;
    PRIMARY_KEY_DATASOURCE: string;
    COLUMNS_MAPPING: { DEPOT_CHEQUE: Model_DeclencheurColumnMapping[], RETRAIT_CHEQUE: Model_DeclencheurColumnMapping[], DEPOT_FACTURE: Model_DeclencheurColumnMapping[] };
}

export class Model_DeclencheurActionSyncKanbanDatasWithDatasourceOptions {
    NUM_DATASOURCE: string;
    KANBAN_ID: string;
}

export class Model_DeclencheurActionInstantiateWorkflowOptions {
    NUM_WORKFLOW: string;
    WORKFLOW_PARAMS: { WORKFLOW_COMPONENT: string, TYPE_DEFAULT_VALUE: TYPE_DEFAULT_VALUE, DEFAULT_VALUE: any }[];
}

export class Model_DeclencheurActionPrintDocumentOptions {
    DOCUMENT_HTML: string;
}

export class Model_DeclencheurActionSaveDocumentPdfOptions {
    DOCUMENT_HTML: string;
}

export class Model_DeclencheurActionPrintTicketOptions {
    TICKET_MODELE: any;
    NB_PRINT: number;
}

export class Model_DeclencheurActionCancelExecutionWorkflowOptions {
    WORKFLOW_ID_COMPONENT_NAME: string;
}

export class Model_DeclencheurActionDatasourceFromInputAgendaPlannerOptions {
    NUM_DATASOURCE: string;
    AGENDA_PLANNER_ID: string;
    CODE_CLIENT: string;
}

export class Model_DeclencheurActionDatasourceFromMultipackInputAgendaPlannerOptions {
    CHECK_SAGE_EMPLACEMENT_OPTIONS: Model_DeclencheurActionCheckSageEmplacementOptions;
    NUM_DATASOURCE: string;
    AGENDA_PLANNER_ID: string;
    COLUMNS_MAPPING: Model_DeclencheurColumnMapping[];
}

export class Model_DeclencheurActionCheckSageEmplacementOptions {
    SAGE_EMPLACEMENT_ID: string;
    SAGE_EMPLACEMENT_NAME_DEST_ID: string;
}

export class Model_DeclencheurUpdateAgentsStatusesFromControleOptions {
    WORKFLOW_COMPONENT_ID: string;
    NUM_DATASOURCE: string;
    DATASOURCE_COLUMN: string;
}

export class Model_DeclencheurColumnMapping {
    PRIMARY_KEY: boolean; 
    DATASOURCE_COLUMN: string; 
    TYPE_DEFAULT_VALUE: TYPE_DEFAULT_VALUE; 
    DEFAULT_VALUE: string;
}

export class Model_ResponseWorkflow {
    ID: number;
    LOCAL_ID: string;
    GUID_SYNCHRONISATION: string;
    NUM_WORKFLOW: string;
    TITRE_RESPONSE_WORKFLOW: string;
    STATUS_WORKFLOW: STATUS_WORKFLOW;
    CURRENT_WORKFLOW_STEP_INDEX: number;
    TOTAL_WORKFLOW_STEPS_COUNT: number;
    DATE_DEBUT_WORKFLOW: string;
    DATE_FIN_WORKFLOW: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    USER_ID: string;
    SYNCED: boolean;
    DATE_SYNCHRONISATION: string;

    RESPONSE_STEPS: Model_ResponseWorkflowStep[];
    WORKFLOW: Model_Workflow;
    AGENT: Model_Agent;

    WORKFLOW_SESSION_ID?: string;
}

export class Model_ResponseWorkflowStep {
    ID: number;
    GUID_SYNCHRONISATION: string;
    NUM_WORKFLOW: string;
    NUM_WORKFLOWSTEP: string;
    WORKFLOW_STEP_INDEX: number;
    FORM_RESPONSES: any;
    DATE_DEBUT_STEP: string;
    DATE_FIN_STEP: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    RESPONSE_WORKFLOW_ID: number;
    GUID_RESPONSE_WORKFLOW: string;
    GEOLOCALISATIONS: GeolocationPoint[];

    WORKFLOW_STEP: Model_WorkflowStep;
    LOGS_DECLENCHEURS: any[];
}

export enum STATUS_WORKFLOW {
    ALL = -2,
    ANNULE = -1,
    EN_COURS = 0,
    EN_PAUSE = 1,
    ACHEVE = 2,
}

export const STATUS_WORKFLOW_LABELS: {[key: string]: string} = {
    '-2': 'Tous les workflows',
    '-1': "Workflows Annulés",
    '0': "Workflows en cours",
    '1': "Workflows en pause",
    '2': "Workflows Terminés"
}

export const STATUS_WORKFLOW_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: STATUS_WORKFLOW.ALL, mDISPLAY_MEMBER: STATUS_WORKFLOW_LABELS[STATUS_WORKFLOW.ALL] },
    { mVALUE_MEMBER: STATUS_WORKFLOW.ACHEVE, mDISPLAY_MEMBER: STATUS_WORKFLOW_LABELS[STATUS_WORKFLOW.ACHEVE] },
    { mVALUE_MEMBER: STATUS_WORKFLOW.EN_PAUSE, mDISPLAY_MEMBER: STATUS_WORKFLOW_LABELS[STATUS_WORKFLOW.EN_PAUSE] },
    { mVALUE_MEMBER: STATUS_WORKFLOW.EN_COURS, mDISPLAY_MEMBER: STATUS_WORKFLOW_LABELS[STATUS_WORKFLOW.EN_COURS] },
    { mVALUE_MEMBER: STATUS_WORKFLOW.ANNULE, mDISPLAY_MEMBER: STATUS_WORKFLOW_LABELS[STATUS_WORKFLOW.ANNULE] },
];

export class StartupInfos_PeripheriqueSynchronisation {
    WORKFLOWS: Model_Workflow[] = [];
    DATASOURCES: Model_Datasource[] = [];
    VARIABLES_ENVIRONNEMENT: Model_VariableEnvironnementUser[] = [];
    PAUSED_RESPONSES_WORKFLOWS: Model_ResponseWorkflow[] = [];
}

export class StartupInfos_ExecutionWorkflows {
    WORKFLOWS: Model_Workflow[] = [];
}

export enum TYPE_PERIODE {
    TODAY = 1,
    YESTERDAY = 2,
    WEEK = 3,
    MONTH = 4,
    CUSTOM = 5,
}

export const TYPE_PERIODE_LABELS: {[key: string]: string} = {
    1: 'Aujourd\'hui',
    2: "Hier",
    3: "Cette semaine",
    4: "Ce mois",
    5: "Personnalisé"
}

export const TYPE_PERIODE_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_PERIODE.TODAY, mDISPLAY_MEMBER: TYPE_PERIODE_LABELS[TYPE_PERIODE.TODAY] },
    { mVALUE_MEMBER: TYPE_PERIODE.YESTERDAY, mDISPLAY_MEMBER: TYPE_PERIODE_LABELS[TYPE_PERIODE.YESTERDAY] },
    { mVALUE_MEMBER: TYPE_PERIODE.WEEK, mDISPLAY_MEMBER: TYPE_PERIODE_LABELS[TYPE_PERIODE.WEEK] },
    { mVALUE_MEMBER: TYPE_PERIODE.MONTH, mDISPLAY_MEMBER: TYPE_PERIODE_LABELS[TYPE_PERIODE.MONTH] },
    { mVALUE_MEMBER: TYPE_PERIODE.CUSTOM, mDISPLAY_MEMBER: TYPE_PERIODE_LABELS[TYPE_PERIODE.CUSTOM] },
];

export class QueryParams_ResponseWorkflow extends BaseQueryParams {
    TYPE_PERIODE = TYPE_PERIODE.TODAY;
    BORNE_INF: string = null;
    BORNE_SUP: string = null;
    USERS_IDS: string[] = [];
    NUMS_WORKFLOWS: string[] = [];
    STATUS_WORKFLOW: STATUS_WORKFLOW[] = [];
    SYNCED?: boolean; 

    constructor() {
        super();
        const parsedProperties = QueryParams_ResponseWorkflow.parseDates(this);
        this.BORNE_INF = parsedProperties.BORNE_INF;
        this.BORNE_SUP = parsedProperties.BORNE_SUP;
    }

    static parseDates(_queryParams: QueryParams_ResponseWorkflow) {
        var periodDateInf = null;
        var periodDateSup = null;
        var today = moment();

        switch(_queryParams.TYPE_PERIODE) {
            case TYPE_PERIODE.TODAY: // AUJOURDHUI
                periodDateInf = today.clone();
                periodDateSup = today.clone();
                periodDateInf.set({hour:0,minute:0,second:0,millisecond:0});
                periodDateSup.set({hour:23,minute:59,second:59,millisecond:59});
                break;

            case TYPE_PERIODE.YESTERDAY: // HIER
                periodDateInf = today.clone().subtract(1, 'day');
                periodDateSup = today.clone().subtract(1, 'day');
                periodDateInf.set({hour:0,minute:0,second:0,millisecond:0});
                periodDateSup.set({hour:23,minute:59,second:59,millisecond:59});
                break;

            case TYPE_PERIODE.WEEK: // CETTE SEMAINE
                periodDateInf = today.clone().startOf('week').add(1, 'day');
                periodDateSup = today.clone().endOf('week').add(1, 'day');
                periodDateInf.set({hour:0,minute:0,second:0,millisecond:0});
                periodDateSup.set({hour:23,minute:59,second:59,millisecond:59});
                break;

            case TYPE_PERIODE.MONTH: // CE MOIS
                periodDateInf = today.clone().startOf('month');
                periodDateSup = today.clone().endOf('month');
                periodDateInf.set({hour:0,minute:0,second:0,millisecond:0});
                periodDateSup.set({hour:23,minute:59,second:59,millisecond:59});
                break;

            case TYPE_PERIODE.CUSTOM:
                periodDateInf = moment(_queryParams.BORNE_INF, 'YYYY-MM-DD HH:mm');
                periodDateSup = moment(_queryParams.BORNE_SUP, 'YYYY-MM-DD HH:mm');
                break;
        }
        if (periodDateInf != null && periodDateSup != null) {
            _queryParams.BORNE_INF = periodDateInf.format('YYYY-MM-DD HH:mm');
            _queryParams.BORNE_SUP = periodDateSup.format('YYYY-MM-DD HH:mm');
        }

        return _queryParams;
    }
}

export class StartupInfos_HistoriqueResponseWorkflows {
    WORKFLOWS: Model_Workflow[] = [];
    AGENTS: Model_Agent[] = [];
}

export class ExecutionWorkflowStep {
    workflowStep: Model_WorkflowStep;
    workflowStepFormModel: DynamicFormControlModel[] = [];
    workflowStepFormGroup: FormGroup;
}

export enum STATUS_PERIPHERIQUE {
    NOT_REGISTERED = 0,
    REGISTERED = 1,
    DISABLED = 2,
    ENABLED = 3
}

export enum TYPE_GEOLOCALISATION {
    AUCUNE = 0,
    PONTUELLE = 1,
    ACTIVE = 2
}

export const TYPE_GEOLOCALISATION_LABELS: {[key: string]: string} = {
    0: 'Aucune',
    1: "Ponctuelle",
    2: "Active"
}

export const TYPE_GEOLOCALISATION_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_GEOLOCALISATION.AUCUNE, mDISPLAY_MEMBER: TYPE_GEOLOCALISATION_LABELS[TYPE_GEOLOCALISATION.AUCUNE] },
    { mVALUE_MEMBER: TYPE_GEOLOCALISATION.PONTUELLE, mDISPLAY_MEMBER: TYPE_GEOLOCALISATION_LABELS[TYPE_GEOLOCALISATION.PONTUELLE] },
    { mVALUE_MEMBER: TYPE_GEOLOCALISATION.ACTIVE, mDISPLAY_MEMBER: TYPE_GEOLOCALISATION_LABELS[TYPE_GEOLOCALISATION.ACTIVE] },
];

export class GeolocationPoint {
    latitude: number;
    longitude: number;
    accuracy: number;
    dateLocation: string;
}

export class DeviceInfos {
    marque: string;
    modele: string;
    macAddress: string;
    androidID: string;
    appVersion: string;
}

export class DownloadUpdatesInfos {
    filename: string;
    description: string;
    url: string;
    version: string;
}

export class AppInfos {
    APP_VERSION_ID: string; 
    APP_VERSION_DISPLAY: string; 
    APP_COMMIT_SHA: string;
    CODE_SOCIETE: string;
    NOM_SOCIETE: string;
}

export class UploadLocalDatabaseInfos {
    UPLOAD_URL: string;
}


export enum FORMAT_NUMBER {
    NUMBER = 1,
    CURRENCY = 2,
}

export class UpdateInfos {
    RELEASE_VERSION_CODE: string;
    RELEASE_VERSION_DISPLAY: string;
    RELEASE_DATE: string;
    RELEASE_NOTE: string;
    RELEASE_URL: string;
}

export class TraceLog {
    type: string;
    timeStamp: string;
    value: string;
}

export class Model_LogVariableEnvironnementUser {
    ID: number;
    GUID_SYNCHRONISATION: string;
    VARIABLE_ENVIRONNEMENT_ID: string;
    VARIABLE_ENVIRONNEMENT_USER_ID: string;
    NOM_VARIABLE: string;
    DATE_LOG: string;
    ACTION_LOG: ACTION_LOG;
    RESULT_LOG: string;
    BEFORE_VALUE: string;
    CURRENT_VALUE: string;
    USER_ID: string;
    PARAMS_LOG: any;
    SYNCED: boolean;
    DATE_SYNCHRONISATION: string;
    VARIABLE_ENVIRONNEMENT_USER: Model_VariableEnvironnementUser;
    AGENT: Model_Agent;
}

export enum ACTION_LOG {
    INSTANTIATION = 1,
    MODIFICATION = 2,
    REINITIALISATION = 3
}

export const ACTION_LOG_LABELS: {[key: string]: string} = {
    '1': 'Instantiation',
    '2': "Modification",
    '3': "Réinitialisation",
}

export class Model_Synchronisation {
    GUID_SYNCHRONISATION?: string;
    LIBELLE_SYNCHRONISATION?: string;
    DATE_CREATION?: string;
    DATE_DEBUT_SYNCHRONISATION?: string;
    DATE_FIN_SYNCHRONISATION?: string;
    RESULT_SYNCHRONISATION?: string;
    TYPE_SYNCHRONISATION: TYPE_SYNCHRONISATION;
    STATUS_SYNCHRONISATION?: STATUS_SYNCHRONISATION;
    USER_ID?: string;
    PERIPHERIQUE_ID?: string;
    SYNCHRONISATION_TASKS?: Model_SynchronisationTask[];
}

export class Model_SynchronisationTask {
    GUID_SYNCHRONISATION?: string;
    GUID_SYNCHRONISATION_TASK?: string;
    ORDER_SYNCHRONISATION_TASK?: number;
    TYPE_SYNCHRONISATION_TASK: TYPE_SYNCHRONISATION_TASK;
    DATE_DEBUT_SYNCHRONISATION_TASK?: string;
    DATE_FIN_SYNCHRONISATION_TASK?: string;
    SYNCHRONISATION_TASK_PARAMS?: any;
}

export enum TYPE_SYNCHRONISATION {
    PERIPHERIQUE = 1,
    RUNNER = 2
}

export enum STATUS_SYNCHRONISATION {
    ALL = -1,
    EN_ATTENTE = 0,
    EN_COURS = 1,
    TERMINE = 2,
    ANNULE = 3,
    ECHEC = 4
}

export enum TYPE_SYNCHRONISATION_TASK {
    PERIPHERIQUE_RESPONSE_WORKFLOW = 1,
    PERIPHERIQUE_VARIABLE_ENVIRONNEMENT = 2,
    PERIPHERIQUE_DATASOURCE = 3,
    PERIPHERIQUE_LOG_VARIABLE = 4,
}

export class Model_Perimetre {
    ID: string;
    LIBELLE: string;
    DATE_CREATION?: string;
    DATE_MODIFICATION?: string;
    DATE_SUPPRESSION?: string;
    DATASOURCE: { 
        TYPE_DATASOURCE: number; 
        DATASOURCE_ID: string; 
    };
    REPORTING_PARAMS?: {
        COLUMNS?: { COLUMN_ID: string; ORDER: number; DATASOURCE_ID: string; }[]
    };
    FILE_PARAMS?: {
        FILE_TEMPLATE?: any;
        FILE_START_ROW_NUMBER?: number;
        FILE_SEPARATOR?: string;
        STRUCTURES: {[key:number]: any[]};
    };
    GLOBAL_FILTERS?: { TYPE_PERIODE: number; BORNE_INF: string; BORNE_SUP: string; USERS_IDS: string[]; STATUS_WORKFLOW: number[]; };
    USER_ID?: string;
    IS_LOCKED?: boolean;
    TYPE_REPORTING: TYPE_REPORTING;
}

export enum TYPE_REPORTING {
    REPORTING = 1,
    EXCEL = 2,
    TEXT = 3,

    SOUDOTEC_RANGEMENT_STOCK_SAGE_EXPORT = 100,
}

export const TYPE_REPORTING_LABELS: {[key: string]: string} = {
    1: 'Reporting',
    2: "Excel",
    3: "Texte",
    100: "Fichier d'import SAGE / Rangement Stock"
}

export const TYPE_REPORTING_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_REPORTING.REPORTING, mDISPLAY_MEMBER: TYPE_REPORTING_LABELS[TYPE_REPORTING.REPORTING] },
    { mVALUE_MEMBER: TYPE_REPORTING.EXCEL, mDISPLAY_MEMBER: TYPE_REPORTING_LABELS[TYPE_REPORTING.EXCEL] },
    { mVALUE_MEMBER: TYPE_REPORTING.TEXT, mDISPLAY_MEMBER: TYPE_REPORTING_LABELS[TYPE_REPORTING.TEXT] },
    { mVALUE_MEMBER: TYPE_REPORTING.SOUDOTEC_RANGEMENT_STOCK_SAGE_EXPORT, mDISPLAY_MEMBER: TYPE_REPORTING_LABELS[TYPE_REPORTING.SOUDOTEC_RANGEMENT_STOCK_SAGE_EXPORT] },
];

export class Model_ReportingGenerationResult {
    PERIMETRE: Model_Perimetre;
    TYPE_REPORTING: TYPE_REPORTING;
    FILE_CONTENT: any;
}

export class RunnerHubInfos {
    CONNECTION_ID: string;
    DATE_CONNEXION: string;
    SOCIETE_ID: string;
    NOM_SOCIETE: string;
    CODE_SYSTEME_INFORMATION: string;
    VERSION_SYSTEME_INFORMATION: string;
    DOMAINE: string;
    RUNNER_USERNAME: string;
    RUNNER_PASSWORD: string;
    RUNNER_DATE_INSTALLATION: string;
    RUNNER_DB_VERSION: string;
    STATUS_LAST_SYNC: STATUS_RUNNER_TASK;
    RESULT_LAST_SYNC: string;
    DATE_LAST_SYNC: string;
    DATE_NEXT_SYNC: string;
}

export enum TYPE_RUNNER_TASK_ID {
    SYNCHRONISATION_STRUCTURES = 1,
    SYNCHRONISATION_DOCUMENTS = 2,
    SOUDOTEC_COMMAND_UPDATE = 3,
    SYNCHRONISATION_DOCUMENTS_MIBEM = 4,
    SYNCHRONISATION_PARAMETRES_MIBEM = 5,
}

export const TYPE_RUNNER_TASK_LABELS: {[key: string]: string} = {
    1: 'Sync des structures [SAGE]',
    2: "Sync des documents [SAGE]",
    3: "Mise à jour de documents [SOUDOTEC]",
    4: "Synchronisation des documents [MIBEM]",
    5: "Synchronisation des paramètres [MIBEM]",
}

export const TYPE_RUNNER_TASK_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_RUNNER_TASK_ID.SYNCHRONISATION_STRUCTURES, mDISPLAY_MEMBER: TYPE_RUNNER_TASK_LABELS[TYPE_RUNNER_TASK_ID.SYNCHRONISATION_STRUCTURES] },
    { mVALUE_MEMBER: TYPE_RUNNER_TASK_ID.SYNCHRONISATION_DOCUMENTS, mDISPLAY_MEMBER: TYPE_RUNNER_TASK_LABELS[TYPE_RUNNER_TASK_ID.SYNCHRONISATION_DOCUMENTS] },
    { mVALUE_MEMBER: TYPE_RUNNER_TASK_ID.SOUDOTEC_COMMAND_UPDATE, mDISPLAY_MEMBER: TYPE_RUNNER_TASK_LABELS[TYPE_RUNNER_TASK_ID.SOUDOTEC_COMMAND_UPDATE] }
];

export class TYPE_RUNNER_TASK {
    ID: TYPE_RUNNER_TASK_ID;
    LIBELLE: string;
    CODE_SOCIETE: string;
    IS_DECLENCHEUR_JOB: boolean;
}

export enum PERIODICITE_RUNNER_TASK {
    PONCTUELLE = 1,
    RECCURENTE = 2,
}

export const PERIODICITE_RUNNER_TASK_LABELS: {[key: string]: string} = {
    1: 'Ponctuelle',
    2: "Récurrente",
}

export const PERIODICITE_RUNNER_TASK_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: PERIODICITE_RUNNER_TASK.PONCTUELLE, mDISPLAY_MEMBER: PERIODICITE_RUNNER_TASK_LABELS[PERIODICITE_RUNNER_TASK.PONCTUELLE] },
    { mVALUE_MEMBER: PERIODICITE_RUNNER_TASK.RECCURENTE, mDISPLAY_MEMBER: PERIODICITE_RUNNER_TASK_LABELS[PERIODICITE_RUNNER_TASK.RECCURENTE] },
];

export class Model_RunnerTask {
    ID: number;
    GUID_SYNCHRONISATION: string;
    DATE_SYNCHRONISATION: string;
    IS_SYNCED: boolean;
    LIBELLE_TASK: string;
    TYPE_TASK: TYPE_RUNNER_TASK_ID;
    TASK_PARAMS: Model_RunnerTaskJob[];
    STATUS_TASK: STATUS_RUNNER_TASK;
    DATE_DEBUT: string;
    DATE_FIN: string;
    RESULT_JOB: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    USER_ID: string;
}

export class Model_RunnerTaskJob {
    JOB_ID: string;
    TYPE_JOB: TYPE_RUNNER_TASK_ID;
    JOB_PARAMS: any;
    STATUS_JOB: number;
    DATE_DEBUT: string;
    DATE_FIN: string;
    RESULT_JOB: string;
}

export enum STATUS_RUNNER_TASK {
    ECHEC = -2,
    ANNULE = -1,
    EN_ATTENTE = 0,
    EN_COURS = 1,
    TERMINE = 2,
}

export const STATUS_RUNNER_TASK_LABELS: {[key: string]: string} = {
    '-2': 'Echec',
    '-1': "Annulé",
    '0': "En attente",
    '1': "En cours",
    '2': "Terminé",
}

export enum SAGE_DOMAINE {
    VENTE = 0,
    ACHAT = 1
}

export const SAGE_DOMAINES_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: SAGE_DOMAINE.VENTE, mDISPLAY_MEMBER: "Vente" },
    { mVALUE_MEMBER: SAGE_DOMAINE.ACHAT, mDISPLAY_MEMBER: "Achat" },
];

export enum SAGE_TYPE_DOCUMENT {
    VENTE_DEVIS = 0,
    VENTE_BON_COMMANDE = 1,
    VENTE_PREPARATION_LIVRAISON = 2,
    VENTE_BON_LIVRAISON = 3,
    VENTE_BON_RETOUR = 4,
    VENTE_BON_AVOIR_FINANCIER = 5,
    VENTE_FACTURE = 6,
    VENTE_FACTURE_COMPTABILISE = 7,

    ACHAT_DEMANDE_ACHAT = 10,
    ACHAT_PREPARATION_COMMANDE = 11,
    ACHAT_BON_COMMANDE = 12,
    ACHAT_BON_LIVRAISON = 13,
    ACHAT_BON_RETOUR = 14,
    ACHAT_BON_AVOIR_FINANCIER = 15,
    ACHAT_FACTURE = 16,
    ACHAT_FACTURE_COMPTABILISE = 17,
}

export const SAGE_TYPES_DOCUMENTS_OPTIONS: any[] = [
    { ID: SAGE_TYPE_DOCUMENT.VENTE_DEVIS, NAME: "Devis", DOMAINE_ID: 0, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'Accepté' }] },
    { ID: SAGE_TYPE_DOCUMENT.VENTE_BON_COMMANDE, NAME: "Bons de commande", DOMAINE_ID: 0, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'A Préparer' }] },
    { ID: SAGE_TYPE_DOCUMENT.VENTE_PREPARATION_LIVRAISON, NAME: "Préparations de livraison", DOMAINE_ID: 0, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'A livrer' }] },
    { ID: SAGE_TYPE_DOCUMENT.VENTE_BON_LIVRAISON, NAME: "Bons de livraison", DOMAINE_ID: 0, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'A facturer' }] },
    { ID: SAGE_TYPE_DOCUMENT.VENTE_BON_RETOUR, NAME: "Bons de retour", DOMAINE_ID: 0, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'A facturer' }] },
    { ID: SAGE_TYPE_DOCUMENT.VENTE_BON_AVOIR_FINANCIER, NAME: "Bons d'avoir financier", DOMAINE_ID: 0, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'A facturer' }] },
    { ID: SAGE_TYPE_DOCUMENT.VENTE_FACTURE, NAME: "Factures", DOMAINE_ID: 0, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'A comptabiliser' }] },
    { ID: SAGE_TYPE_DOCUMENT.VENTE_FACTURE_COMPTABILISE, NAME: "Factures comptabilisées", DOMAINE_ID: 0, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'A comptabiliser' }] },

    { ID: SAGE_TYPE_DOCUMENT.ACHAT_DEMANDE_ACHAT, NAME: "Demandes d'achat", DOMAINE_ID: 1, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'Accepté' }] },
    { ID: SAGE_TYPE_DOCUMENT.ACHAT_PREPARATION_COMMANDE, NAME: "Préparations de commande", DOMAINE_ID: 1, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'Accepté' }] },
    { ID: SAGE_TYPE_DOCUMENT.ACHAT_BON_COMMANDE, NAME: "Bons de commande", DOMAINE_ID: 1, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'Envoyé' }] },
    { ID: SAGE_TYPE_DOCUMENT.ACHAT_BON_LIVRAISON, NAME: "Bons de livraison", DOMAINE_ID: 1, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'Réceptionné' }] },
    { ID: SAGE_TYPE_DOCUMENT.ACHAT_BON_RETOUR, NAME: "Bons de retour", DOMAINE_ID: 1, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'Facturé' }] },
    { ID: SAGE_TYPE_DOCUMENT.ACHAT_BON_AVOIR_FINANCIER, NAME: "Bons d'avoir financier", DOMAINE_ID: 1, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'Facturé' }] },
    { ID: SAGE_TYPE_DOCUMENT.ACHAT_FACTURE, NAME: "Factures", DOMAINE_ID: 1, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'A comptabiliser' }] },
    { ID: SAGE_TYPE_DOCUMENT.ACHAT_FACTURE_COMPTABILISE, NAME: "Factures comptabilisées", DOMAINE_ID: 1, STATUTS_DOCUMENTS: [{ ID: 0, TEXT: 'Saisi' }, { ID: 1, TEXT: 'Confirmé' }, { ID: 2, TEXT: 'A comptabiliser' }] },
];

export class Model_RunnerDeclencheur {
    ID: number;
    TYPE_TASK: TYPE_RUNNER_TASK_ID;
    TYPE_DECLENCHEUR: TYPE_DECLENCHEUR;
    CONDITIONS_DECLENCHEUR: any;
    DECLENCHEUR_PARAMS: any;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
}

export class Model_RunnerDeclencheurStartWorkflowParams
{
    TYPE_DESTINATAIRES: string;
    DESTINATAIRES_AGENTS: string[];
    DESTINATAIRES_TEAMS: string[];
    NUM_WORKFLOW: string;
    COMPONENTS_MAPPING: any;
}

export class Model_RunnerDeclencheurNotificationParams
{
    TYPE_DESTINATAIRES: string;
    DESTINATAIRES_AGENTS: string[];
    DESTINATAIRES_TEAMS: string[];
    CONTENU_NOTIFICATION: string;
}

export enum STATUS_EXECUTION_DECLENCHEUR {
    SUCCESS = 1,
    NOT_EXECUTED = 0,
    FAILED = -1
}

export const STATUS_EXECUTION_DECLENCHEUR_LABELS: {[key: string]: string} = {
    '1': 'Execution terminée',
    '0': 'Non executé',
    '-1': 'Erreur lors de l\'execution'
}

